import React, { useEffect, useState } from "react";
import Button from "../../Button/Button";
import Modal from "../Modal/Modal";
import styles from "../BuyConfirm/BuyConfirm.module.scss";
import { formatPrice, toFix } from "../../../../utils/utils";
import { useSelector } from "react-redux";
import Select from "../../Formik/Select/Select";
import { PAYMENTMETHODS } from "../../../../utils/constants";
import ErrorText from "../../Formik/ErrorText/ErrorText";
import { getWalletBalanceAction } from "../../../../features/user/userSlice";
import { useDispatch } from "react-redux";

const MatchConfirm = ({
  show,
  handleClose,
  order,
  handleMatchOrder,
  setPaymentMode,
  paymentMode,
  balanceObj,
  orderType,
}) => {
  const dispatch = useDispatch();
  const [balanceError, setBalanceError] = useState(null);
  const tokenBalance = useSelector((state) => state.users.tokenBalance);
  const [portfolioBalance, setPortfolioBalance] = useState(0);

  const getWalletBalance = async () => {
    try {
      const response = await dispatch(getWalletBalanceAction());
      if (response.status === 200) {
        setPortfolioBalance(response.data.data?.amount);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWalletBalance();
  }, []);

  useEffect(() => {
    if (show) {
      if (orderType === "BUY") {
        const selectedWalletBalance = balanceObj[paymentMode];
        const totalOrderAmount = Number(order.quantity) * Number(order.price);
        setBalanceError(null);
        if (portfolioBalance < totalOrderAmount) {
          setBalanceError(
            "Insufficient wallet balance. Please add funds to your wallet or select another wallet."
          );
          return;
        }
      }
    }
  }, [paymentMode, show, portfolioBalance, order, orderType]);

  useEffect(() => {
    if (show) {
      if (orderType === "BUY") {
        setPaymentMode(PAYMENTMETHODS[0].label);
      } else {
        if (order?.quantity > Number(tokenBalance)) {
          setBalanceError("Insufficient token balance.");
        } else {
          setBalanceError(null);
        }
      }
    } else {
      setBalanceError(null);
    }
  }, [show, order, tokenBalance, orderType]);

  return (
    <>
      <Modal
        className={styles.buy_modal}
        show={show}
        handleClose={handleClose}
        title="Match Order"
      >
        <ul>
          <li>
            <h6>Quantity</h6>
            <h4>
              {formatPrice(Number(order?.quantity))}{" "}
              {order?.master_tokens_configuration?.name}{" "}
            </h4>
          </li>
          <li>
            <h6>At Price</h6>
            <h4>$ {formatPrice(Number(order?.price))} </h4>
          </li>
          <li>
            <h6>Total</h6>
            <h4>
              ${" "}
              {formatPrice(
                Number(Number(order?.price) * Number(order?.quantity))
              )}{" "}
            </h4>
          </li>
          {/* {orderType === "BUY" && (
            <>
              <li>
                <h6>Balance Method</h6>
                <h4>STBL Wallet</h4>
              </li>
              <li>
                <h6 className={styles.balance}>STBL Wallet Bal: </h6>
                <h4>${formatPrice(Number(portfolioBalance))} </h4>
              </li>
              <li>{balanceError && <ErrorText>{balanceError}</ErrorText>}</li>
            </>
          )} */}

          {orderType === "BUY" && (
            <>
              <li>
                <h6>Balance Method</h6>
                <h4>STBL Wallet</h4>
              </li>
              <li>
                <h6 className={styles.balance}>STBL Wallet Bal: </h6>
                <h4>${toFix(Number(portfolioBalance), 3)} </h4>
              </li>
            </>
          )}

          {balanceError && (
            <div className={styles.errorContainer}>
              <ErrorText>{balanceError}</ErrorText>
            </div>
          )}

          {orderType === "SELL" && (
            <li>
              <h6>{order?.master_tokens_configuration?.name} Balance: </h6>
              <h4>{formatPrice(Number(tokenBalance))}</h4>
            </li>
          )}
        </ul>
        {balanceError && (
          <div className={styles.errorContainer}>
            <ErrorText>{balanceError}</ErrorText>
          </div>
        )}
        <Button
          fluid
          variant="yellow_btn"
          className={styles.submit_btn}
          onClick={() => {
            handleMatchOrder();
            handleClose();
          }}
          disabled={balanceError !== null}
        >
          Confirm Match Order
        </Button>
      </Modal>
    </>
  );
};

export default MatchConfirm;
